module.exports = __webpack_public_path__ + "img/fogg-message-sent.4ee9e408.svg";